<section style="display: inline-flex; height: 30px; font-family: Lato">
    <select (change)="officeSelected($event)">
        <ng-container *ngFor="let o of offices">
            <option value="{{o.guid}}">{{o.name}}</option>
        </ng-container>
    </select>
    <ng-container>
        <select (change)="floorSelected($event)">
            <ng-container *ngFor="let f of floors">
                <option *ngIf="f.floortype=='WITH_FLOOR_PLAN' || f.floortype=='WITH_BACKGROUND_IMAGE'" value="{{f._id}}">{{f.floorName}}</option>
            </ng-container>
        </select>
    </ng-container>

    <ng-container>
        <select (change)="seatSelected($event)">
            <option value="--">--</option>
            <ng-container *ngFor="let s of seatList; let i = index">
                <option *ngIf="s.properties.status=='BOOKED'" value="{{i}}">{{s.properties.name}}</option>
            </ng-container>
        </select>
    </ng-container>

    <ng-container>
        <select (change)="setFilter($event)">
            <option value="--">--</option>
            <option value="notepad">Notepad</option>
            <option value="desktop">Desktop</option>
            <option value="laptop">Laptop</option>
        </select>
    </ng-container>
</section>

<div *ngIf="isDataReady" style="overflow: hidden;">
    <app-floor-layout (renderCompleteCallback)="isFloorRendered($event)" [selectedSeat]="selectedSeat" [isFloorPlanAvailable]="true" [FLOOR_DATA]="layout" [filter]="filter" [changeOn]="changeOn">
    </app-floor-layout>
</div>

<div *ngIf="!isDataReady" class="loader">
    <span>Please wait while we load the Data...</span>
</div>